import React, { useEffect, useState } from 'react';
import { FaUserGroup } from 'react-icons/fa6';
import { BsArrowDown, BsArrowUp } from 'react-icons/bs';
import { FaRegCalendarAlt } from 'react-icons/fa';
import SellerReportBarChart from '../../components/Seller/SellerReportBarChart/SellerReportBarChart';
import { USER_URL } from '../../constant/api';
import { MdCollectionsBookmark } from 'react-icons/md';
import dayjs from "dayjs";
import "jspdf-autotable";
import jsPDF from "jspdf";
import SubAdminReportChart from '../../components/AdminReportChart/SubAdminReportChart';

function SubAdminReport() {
    const [salesData, setSalesData] = useState({}); // Initialize as an object
    const [selectedYear, setSelectedYear] = useState(2024);
    const [filteredSalesData, setFilteredSalesData] = useState([]);
    const [totalCustomers, setTotalCustomers] = useState(0);
    const [totalRevenue, setTotalRevenue] = useState(0);

    // ===================== PAYMENT (COMMENTED) =====================
    // Dummy payment data (not from backend)
    /*
    const paymentData = [
        {
            customerName: 'John Doe',
            transactionId: 'TXN12345',
            date: '2024-03-02',
            totalAmount: '₹5000',
            paymentMethod: 'Credit Card',
            status: 'Completed'
        },
        {
            customerName: 'Jane Smith',
            transactionId: 'TXN67890',
            date: '2024-03-01',
            totalAmount: '₹3000',
            paymentMethod: 'UPI',
            status: 'Pending'
        }
    ];
    */
    // ===============================================================

    const fetchData = async (url, setState) => {
        try {
            const response = await USER_URL.get(url);
            setState(response.data.Data || []);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        // Fetch sales data for the selected year
        fetchData(`/orders/subadmin/sales-by-year/?year=${selectedYear}`, (data) => {
            setSalesData(prev => ({
                ...prev,
                [selectedYear]: data,
            }));
        });
    }, [selectedYear]);

    useEffect(() => {
        if (salesData[selectedYear]) {
            setFilteredSalesData(salesData[selectedYear]);
        }
    }, [salesData, selectedYear]);

    const fetchTotalData = async (url, setter) => {
        try {
            const response = await USER_URL.get(url);
            setter(response.data.data[0] || []);
            console.log(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchTotalData(`/orders/subadmin/total-customers/`, setTotalCustomers);
        fetchTotalData(`/orders/subadmin/revenues/`, setTotalRevenue);
    }, []);

    const handleYearChange = (e) => {
        const year = parseInt(e.target.value, 10);
        setSelectedYear(year);
    };

    const getTotalSales = () => {
        return filteredSalesData.reduce((total, month) => total + month.sales, 0);
    };

    // ===================== PAYMENT PDF (COMMENTED) =====================
    /*
    const generatePDF = () => {
        const doc = new jsPDF();

        doc.setFontSize(20);
        doc.text("Payment Report", 14, 20);

        doc.setFontSize(12);
        doc.text(`Date: ${dayjs().format("DD-MM-YYYY")}`, 14, 30);

        const headers = [["Customer Name", "Transaction ID", "Date", "Total Amount", "Payment Method", "Status"]];

        const data = paymentData.map(payment => [
            payment.customerName,
            payment.transactionId,
            dayjs(payment.date).format("DD-MM-YYYY"),
            payment.totalAmount,
            payment.paymentMethod,
            payment.status
        ]);

        doc.autoTable({
            head: headers,
            body: data,
            startY: 40,
            theme: "striped",
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: { fillColor: [22, 160, 133] }
        });

        doc.save("payment-report.pdf");
    };
    */
    // ===============================================================

    const renderStatCard = (icon, title, value, growth) => (
        <div className="flex justify-between items-center p-4 md:border-r-2">
            <div className="flex items-center space-x-4">
                <div className="text-brand-primary bg-[#E7F7F0] p-2 text-2xl md:text-xs rounded-lg">
                    {icon}
                </div>
                <div>
                    <p className="font-semibold text-xs">{title}</p>
                    <p className="text-gray-600 text-xs line-clamp-1">{value}</p>
                </div>
            </div>
            <div className={`flex items-center text-xs ${growth > 0 ? 'text-green-500' : 'text-red-500'}`}>
                {growth > 0 ? <BsArrowUp className="mr-2" /> : <BsArrowDown className="mr-2" />}
                <p>{growth}%</p>
            </div>
        </div>
    );

    return (
        <div>
            <h1 className="text-2xl font-medium text-green-600 ">Sales</h1>

            <div className="mb-10 border-2 rounded-xl p-2 md:p-5">
                <div className="flex flex-wrap justify-between items-center mb-6">
                    <div>
                        <p className="text-lg font-semibold">Sales in Year</p>
                        <p className="text-xl">{getTotalSales()} sales</p>
                    </div>
                    <div>
                        <select
                            className="border px-4 py-2 rounded-md w-full sm:w-auto"
                            value={selectedYear}
                            onChange={handleYearChange}
                        >
                            <option value="2025">2025</option>
                            <option value="2024">2024</option>
                            <option value="2023">2023</option>
                        </select>
                    </div>
                </div>

                <SellerReportBarChart data={salesData[selectedYear]} />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
                    {renderStatCard(
                        <FaUserGroup />,
                        "Total Customers",
                        totalCustomers.total_customers,
                        totalCustomers.change_percentage
                    )}
                    {renderStatCard(
                        <FaUserGroup />,
                        "Total Revenue",
                        totalRevenue.total_revenue,
                        totalRevenue.change_percentage
                    )}
                </div>
            </div>

            <div className="mb-10">
                <SubAdminReportChart colors={{ line: '#00c853' }} />
            </div>

            {/* ===================== PAYMENT UI (COMMENTED) ===================== */}
            {/*
            <div className="mb-10">
                <h1 className='font-medium text-[32px]'>Payment</h1>
                <div className="flex flex-col my-5 gap-8 lg:flex-row">
                    <div className="flex-1">
                        <div className="rounded-xl text-sm">
                            <div className="overflow-x-auto">
                                <div className="w-full space-y-4">
                                    <div className="grid grid-cols-[1fr,2fr,2fr,2fr,2fr,2fr,1.5fr] font-medium text-brand-button-green-bg">
                                        <div className="text-center">No</div>
                                        <div className="text-center">Customer Name</div>
                                        <div className="text-center">Date</div>
                                        <div className="text-center">Transaction ID</div>
                                        <div className="text-center">Total Amount</div>
                                        <div className="text-center">Payment Method</div>
                                        <div className="text-center">Status</div>
                                    </div>
                                </div>

                                {paymentData.map((payment, index) => (
                                    <div
                                        key={index}
                                        className="grid text-[#2F2E41] min-w-[1024px] grid-cols-[1fr,2fr,2fr,2fr,2fr,2fr,1.5fr] items-center gap-4 py-2"
                                    >
                                        <div className="border rounded-xl p-2 text-center">{index + 1}</div>
                                        <div className="border p-2 rounded-xl text-center">{payment.customerName}</div>
                                        <div className="border p-2 rounded-xl text-center flex items-center justify-center gap-2">
                                            {new Date(payment.date).toLocaleDateString("en-GB")} <FaRegCalendarAlt />
                                        </div>
                                        <div className="border p-2 rounded-xl text-center">{payment.transactionId}</div>
                                        <div className="border p-2 rounded-xl text-center">{payment.totalAmount}</div>
                                        <div className="border p-2 rounded-xl text-center">{payment.paymentMethod}</div>
                                        <div className="border p-2 rounded-xl text-center">{payment.status}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-row justify-end my-5">
                    <button
                        onClick={generatePDF}
                        className="flex justify-center items-center gap-2 text-gray-500 border-2 border-gray-500 rounded-2xl px-10 py-2"
                    >
                        <MdCollectionsBookmark fontSize={25} />
                        Print Receipt
                    </button>
                </div>
            </div>
            */}
            {/* =============================================================== */}
        </div>
    );
}

export default SubAdminReport;
